import { getBooleanConfig } from '@zg-rentals/frontend-config/client';

// Datarouter frontend-config flag that drives IA nav rollout (ZRM-16458). camelCase
// per Datarouter convention (cf. canAccessUserManagement, canAccessFlexibleProperties).
// Owning service RMA, appName zillow-rental-manager-web-next.
export const IA_NAV_CONFIG_FLAG = 'canAccessIaNavigation';

// QA opt-in cookie for the new IA navigation. Injected via zillow-rental-manager-web's
// /featureFlags page (which registers the same key in its FeatureFlagConstants). Kept
// as a QA override on top of the frontend-config rollout flag above.
export const ZRM_IA_NAV_ENABLED = 'ZRM_IA_NAV_ENABLED';

// QA opt-in cookie for the Listings entry point. Duplicated in zrmw's FeatureFlagConstants,
// which is what puts it on the /featureFlags page — keep the two in sync.
export const ZRM_LISTING_LIST_ENABLED = 'ZRM_LISTING_LIST_ENABLED';

// Split owns the Listings population targeting (ZRM-16713), so unlike the IA nav above there
// is deliberately no frontend-config rollout flag in this gate.
export const LISTINGS_SPLIT_FEATURE_NAME = 'zrm_listing_list_page';

// SSR-safe boolean cookie reader. Mirrors zrmw's getCookieAsBoolean: a value of
// 'true' or '1' is truthy. Returns false on the server (no document).
export function getCookieAsBoolean(name: string) {
  if (typeof document === 'undefined') return false;

  const match = document.cookie.split('; ').find((c) => c.startsWith(name + '='));
  if (!match) return false;

  const value = match.slice(name.length + 1);

  return value === 'true' || value === '1';
}

// Resolve IA nav opt-in: Datarouter frontend-config drives real rollout; the QA cookie
// is an override on top. Client-only (call after mount) to avoid an SSR hydration mismatch.
export function getIaNavEnabled() {
  return getBooleanConfig(IA_NAV_CONFIG_FLAG, false) || getCookieAsBoolean(ZRM_IA_NAV_ENABLED);
}
